import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';
import ButtonRounded from '../prefabs/ButtonRounded.js';
import karaoke from '../data/Karaoke.js';

export default class Credits extends AbstractScene {
    constructor() {
        super({
            key: 'Credits',
        });
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        this.allControls = [];
    }

    update() {
        super.update();
    }

    create() {
        this.cameras.main.setBackgroundColor(Colors.Elmt.Black);
        this.missionData = this.getMissionData(karaoke);

        this.lastScreen();
    }

    lastScreen() {
        console.log(
            this.game.data.lang === 'fr'
                ? 'Terminer l’expérience'
                : this.getText('Credits', `buttonLabel`)
        );
        this.back = this.add
            .image(this.width / 2, this.height / 2, this.missionData.endScreenimage)
            .setScale(1);
        this.endButton = new ButtonRounded(
            this,
            this.width / 2,
            this.cameras.main.height - 34,
            160 * 2,
            20 * 2,
            this.game.data.lang === 'fr'
                ? 'Terminer l’expérience'
                : this.getText('Credits', `buttonLabel`),
            Colors.Text.DarkBlue,
            Colors.Elmt.White,
            false,
            Colors.Text.White,
            true,
            false,
            'arrow-right',
            null
        );
        this.endButton.on('pointerdown', () => {
            this.scene.start('Intro');
        });
    }

    formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    }
}
